import Basic from "./Basic";
import ChannelTalk from "./ChannelTalk";
import Emoticon from "./Emoticon";
import File from "./File";
import Image from "./Image";
import Signal from "./Signal";

const ItemBody = {
  Basic,
  ChannelTalk,
  Emoticon,
  File,
  Image,
  Signal,
}

export default ItemBody;